import { TableContainer, Table, Thead, Tbody, Tr, Th, Td, useDisclosure } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import CommessaModal from './CommessaModal';

const CommesseTable = ({commesse}) => {

    const [selectedCommessa, setSelectedCommessa] = useState(null);
    const {isOpen, onOpen, onClose} = useDisclosure();

    useEffect(() => {
        console.log("Changed list of commesse");
    }, [commesse]);

    const handleRowClick = (commessa) => {
        setSelectedCommessa(commessa);
        onOpen();
    }

    
    return (
        <TableContainer>
            <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>Nome</Th>
                        <Th>Inizio</Th>
                        <Th>Fine</Th>
                        <Th>Fatturato</Th>
                        <Th>Da Fatturare</Th>
                        <Th>Stato avanzamento</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {commesse.map((commessa) => (
                        <Tr key={commessa.id} onClick={() => handleRowClick(commessa)} cursor="pointer">
                            <Td>{commessa.name}</Td>
                            <Td>{commessa.start}</Td>
                            <Td>{commessa.end}</Td>
                            <Td>{commessa.total_amount}</Td>
                            <Td>{commessa.to_be_invoiced}</Td>
                            <Td>{commessa.status}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            {selectedCommessa && (
                <CommessaModal commessa={selectedCommessa} isOpen={isOpen} onClose={onClose} />
            )}
        </TableContainer>
    );
};

export default CommesseTable;